module.exports = __webpack_public_path__ + "img/zlindex15.a19036c5.png";